import { put, takeEvery } from "redux-saga/effects";
import * as types from "../types";

function* openModal(action) {
    yield put({ type: types.OPEN_UPDATE_MODAL, payload: action.payload });
}

function* closeModal(action) {
    yield put({ type: types.CLOSE_UPDATE_MODAL, payload: action.payload });
}


function* modalSaga() {
    yield takeEvery(types.OPEN_MODAL, openModal);
    yield takeEvery(types.CLOSE_MODAL, closeModal);
}

export default modalSaga;